module.exports = __webpack_public_path__ + "img/receive_04.65463804.png";